module.exports = __webpack_public_path__ + "media/images/icons/menu_blog-6aeec69eb60cc92cb822fd67f7d51254.svg";